module.exports = __webpack_public_path__ + "img/coverfxPri1.06f63c2d.jpg";